<template>
    <div>
        <!-- {{ source }} -->
        <b-card class="standardpage">
            <b-card-header>
                <b-row>
                    <b-col cols="12" sm="6" class="text-right text-sm-left pt-1">
                        <i :class="inventorylines.icon" class="mr-1"></i>
                        {{ inventorylines.title }}
                        <span v-if="eventcode.length > 0"> for {{ eventtitle }}</span>
                    </b-col>
                </b-row>
            </b-card-header>
            <div v-show="!component" class="availtable datatable">
                <b-card class="w-100pct mb-3">
                    <b-card-body class="py-0">
                        <b-row v-if="!showfilter">
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Issue Date" label-size="sm">
                                    <b-input-group>
                                        <daterangepicker size="sm" ref="issued_at" v-model="issued_at" :opens="'right'"
                                            :locale-data="locale_data" :ranges="locale_ranges" :showDropdowns="true"
                                            :linkedCalendars="false" :single-date-picker="false">
                                        </daterangepicker>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" @click="issued_at = {
                                                startDate: null,
                                                endDate: null,
                                            }
                                                ">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>

                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-row>
                                    <b-col>
                                        <b-form-group label="Source" label-for="type" label-cols="12">
                                            <treeselect instanceId="invoicing_by" type="number" v-model="source"
                                                :clearable="false" :options="options_source"></treeselect>
                                        </b-form-group>
                                    </b-col>
                                    <b-col>
                                        <!-- <b-form-group label="Type" label-for="type" label-cols="12">
                                            <treeselect v-model="type" :clearable="true" :multiple="true"
                                                :options="options_type" placeholder="Show all..."></treeselect>
                                        </b-form-group> -->

                                        <b-form-group label-cols="12" label="Type" label-size="sm">
                                            <treeselect placeholder="Show all..." searchPromptText="Supplier Type..."
                                                v-model="type" :clearable="true" :multiple="true"
                                                :options="options_suppliertype">
                                            </treeselect>
                                        </b-form-group>

                                    </b-col>
                                </b-row>
                            </b-col>

                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label="GDS Locator ( Paste List )" label-for="reflist2" label-cols="12">
                                    <b-input-group class="z-0">
                                        <b-form-tags input-id="reflist2" v-model="locator" tag-variant="primary"
                                            separator=" ,;" placeholder="Paste GDS Locator" size="sm" class="h-29"
                                            add-button-text="+" add-on-change remove-on-delete
                                            add-button-variant="outline-primary"></b-form-tags>
                                        <!-- placeholder="Enter transaction refs separated by space, comma or semicolon" -->
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" @click="locator = null">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>

                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label="Invoice No? ( Paste List )" label-for="reflist" label-cols="12">
                                    <b-input-group class="treeselect_all justify-content-end pr-2px">
                                        <b-form-checkbox-group id="isinvoiced" v-model="isinvoiced"
                                            :options="options_isinvoiced" size="sm" value-field="id" text-field="label"
                                            name="radio-options" class="z-0" style="padding-top: 0.2em">
                                        </b-form-checkbox-group>
                                    </b-input-group>
                                    <b-input-group class="z-0">
                                        <b-form-tags input-id="reflist" v-model="invoiceno" tag-variant="primary"
                                            separator=" ,;" placeholder="Paste Ref (IA519826,IA519827,...)" size="sm"
                                            class="h-29" add-button-text="+" add-on-change remove-on-delete
                                            add-button-variant="outline-primary"></b-form-tags>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" @click="invoiceno = null">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>

                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label="Supplier ( Paste List )" label-for="description" label-cols="12">
                                    <b-input-group class="z-0">
                                        <b-form-tags input-id="description" v-model="description" tag-variant="primary"
                                            separator=" ,;" placeholder="Paste Supplier (Easyjet,Ryanair...)" size="sm"
                                            class="h-29" add-button-text="+" add-on-change remove-on-delete
                                            add-button-variant="outline-primary"></b-form-tags>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" @click="description = null">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>




                            <b-col cols="12" sm="6" md="4" xl="3"> <b-form-group label-cols="12" label="Supplier B/L"
                                    label-size="sm">
                                    <treeselect placeholder="Select blac..." searchPromptText="Type at least 3 chars..."
                                        v-model="blac" :clearable="true" :multiple="true" :async="true"
                                        :load-options="treeselect_loadBLAC" :show-count="true"
                                        :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']"
                                        search-nested>
                                        <div slot="value-label" slot-scope="{ node }">
                                            {{ node.raw.id }}
                                        </div>
                                    </treeselect>
                                </b-form-group>
                            </b-col>

                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-row>
                                    <b-col>
                                        <b-form-group label-cols="12" label="Cost (min)" label-size="sm">
                                            <b-input-group>
                                                <b-form-input v-model="cost.min" :debounce="inventorylines.debounce"
                                                    placeholder="(min)" trim></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        :disabled="!cost.min" @click="cost.min = null; cost.max = null">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col>
                                        <b-form-group label-cols="12" label="Cost (max)" label-size="sm">
                                            <b-input-group>
                                                <b-form-input v-model="cost.max" :debounce="inventorylines.debounce"
                                                    placeholder="(max)" trim></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        :disabled="!cost.max" @click="cost.max = null">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                            </b-col>

                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Travellers" label-size="sm">
                                    <b-input-group>
                                        <b-form-input v-model="travellers" placeholder="Travellers" trim></b-form-input>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" :disabled="!travellers"
                                                @click="travellers = ''">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group> </b-form-group>
                            </b-col>

                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Event" label-size="sm">
                                    <b-input-group class="treeselect_all justify-content-end pr-2px">
                                        <span style="padding-top: 0.3em" class="text-primary"
                                            id="event-blocked">Blocked</span>
                                        <b-form-checkbox id="event-blocked-check" v-model="iseventblocked" class="z-0">
                                        </b-form-checkbox>
                                    </b-input-group>
                                    <treeselect placeholder="Select event..."
                                        searchPromptText="Type at least 4 chars..." v-model="eventcode"
                                        :clearable="true" :multiple="true" :async="true"
                                        :load-options="treeselect_loadEvent" :show-count="true"
                                        :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']"
                                        search-nested @select="treeselect">
                                        <div slot="value-label" slot-scope="{ node }">
                                            {{ node.raw.id }}
                                        </div>
                                    </treeselect>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Client SL A/C" label-size="sm" class="mb-0">
                                    <b-input-group class="treeselect_all justify-content-end pr-2px">
                                        <span style="padding-top: 0.3em" class="text-primary"
                                            id="slaclike-tooltip">Like</span>
                                        <b-form-checkbox id="slaclike" v-model="slaclike_visible" class="z-0">
                                        </b-form-checkbox>
                                        <span style="padding-top: 0.3em" class="text-primary"
                                            id="slac-blocked">Blocked</span>
                                        <b-form-checkbox id="slac-blocked-check" v-model="isslacblocked" class="z-0">
                                        </b-form-checkbox>
                                    </b-input-group>
                                    <b-input-group v-if="!slaclike_visible">
                                        <treeselect placeholder="Select slac..."
                                            searchPromptText="Type at least 3 chars..." v-model="slac" :clearable="true"
                                            :multiple="true" :async="true" :load-options="treeselect_loadSLAC"
                                            :show-count="true" :flatten-search-results="true"
                                            :disable-branch-nodes="true" :matchKeys="['id']" search-nested
                                            :disabled="readonly">
                                            <div slot="value-label" slot-scope="{ node }">
                                                {{ node.raw.id }}
                                            </div>
                                        </treeselect>
                                    </b-input-group>
                                </b-form-group>

                                <b-input-group v-if="slaclike_visible">
                                    <b-form-input v-model="slaclike" :debounce="inventorylines.debounce"
                                        placeholder="Client SL A/C (LIKE %)" trim></b-form-input>
                                    <b-input-group-append>
                                        <b-button size="sm" variant="outline-secondary" :disabled="!slaclike"
                                            @click="slaclike = ''">
                                            <i class="fa fa-remove"></i>
                                        </b-button>
                                    </b-input-group-append>
                                </b-input-group>
                                <!-- </b-form-group> -->
                            </b-col>
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Your Ref/PO" label-size="sm">
                                    <b-input-group>
                                        <b-form-input v-model="yourref" :debounce="inventorylines.debounce"
                                            placeholder="Your Ref/PO"></b-form-input>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" :disabled="!yourref"
                                                @click="yourref = ''">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Date Travel" label-size="sm">
                                    <b-input-group>
                                        <daterangepicker size="sm" ref="travel_at" v-model="travel_at" :opens="'right'"
                                            :locale-data="locale_data" :ranges="locale_ranges" :showDropdowns="true"
                                            :linkedCalendars="true" :single-date-picker="'range'">
                                        </daterangepicker>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" @click="travel_at = {
                                                startDate: null,
                                                endDate: null,
                                            }
                                                ">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>

                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12"
                                    :label="showdeployment ? 'DeploymentId ( Paste List )' : 'TransactionId ( Paste List )'"
                                    label-size="sm" class="mb-0">
                                    <b-input-group class="treeselect_all justify-content-end pr-2px">
                                        <span style="padding-top: 0.3em" class="text-primary"
                                            id="showdeployment-tooltip">Use Deployment</span>
                                        <b-form-checkbox id="showdeployment" v-model="showdeployment" class="z-0">
                                        </b-form-checkbox>
                                    </b-input-group>
                                    <b-input-group class="z-0" v-if="!showdeployment">
                                        <b-form-tags input-id="referenceno" v-model="referenceno" tag-variant="primary"
                                            separator=" ,;" placeholder="Paste TransactionId" size="sm" class="h-29"
                                            add-button-text="+" add-on-change remove-on-delete
                                            add-button-variant="outline-primary"></b-form-tags>
                                        <!-- placeholder="Enter transaction refs separated by space, comma or semicolon" -->
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" @click="referenceno = null">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>

                                </b-form-group>

                                <b-input-group v-if="showdeployment" class="z-0">
                                    <b-form-tags input-id="token" v-model="token" tag-variant="primary" separator=" ,;"
                                        placeholder="Paste DeploymentId" size="sm" class="h-29" add-button-text="+"
                                        add-on-change remove-on-delete
                                        add-button-variant="outline-primary"></b-form-tags>
                                    <!-- placeholder="Enter transaction refs separated by space, comma or semicolon" -->
                                    <b-input-group-append>
                                        <b-button size="sm" variant="outline-secondary" @click="token = null">
                                            <i class="fa fa-remove"></i>
                                        </b-button>
                                    </b-input-group-append>
                                </b-input-group>
                                <!-- </b-form-group> -->
                            </b-col>

                            <!-- <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label="TransactionId ( Paste List )" label-for="referenceno"
                                    label-cols="12">

                                    <b-input-group class="z-0">
                                        <b-form-tags input-id="referenceno" v-model="referenceno" tag-variant="primary"
                                            separator=" ,;" placeholder="Paste TransactionId" size="sm" class="h-29"
                                            add-button-text="+" add-on-change remove-on-delete
                                            add-button-variant="outline-primary"></b-form-tags>                                    
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" @click="referenceno = null">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col> -->
                            <!-- <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label="DeploymentId ( Paste List )" label-for="token" label-cols="12">

                                    <b-input-group class="z-0">
                                        <b-form-tags input-id="token" v-model="token" tag-variant="primary"
                                            separator=" ,;" placeholder="Paste DeploymentId" size="sm" class="h-29"
                                            add-button-text="+" add-on-change remove-on-delete
                                            add-button-variant="outline-primary"></b-form-tags>                                       
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" @click="token = null">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col> -->

                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label="Notes" label-for="notes" label-cols="12">
                                    <b-input-group class="treeselect_all justify-content-end pr-2px">
                                        <b-form-checkbox-group id="hasnotes" v-model="hasnotes"
                                            :options="options_hasnotes" size="sm" value-field="id" text-field="label"
                                            name="radio-options" class="z-0" style="padding-top: 0.2em">
                                        </b-form-checkbox-group>
                                    </b-input-group>
                                    <b-input-group class="z-0">
                                        <b-form-input v-model="notes" placeholder="Notes" trim></b-form-input>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" @click="notes = null">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>

                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label="Statement ( Paste List )" label-for="reflist" label-cols="12">
                                    <b-input-group class="z-0">
                                        <b-form-tags input-id="statement" v-model="statement" tag-variant="primary"
                                            separator=" ,;" placeholder="Paste statement (INTERIM_SVPCONF,...)"
                                            size="sm" class="h-29" add-button-text="+" add-on-change remove-on-delete
                                            add-button-variant="outline-primary"></b-form-tags>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" @click="statement = null">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>

                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-row>
                                    <b-col v-if="user.permissions.includes('conferma.admin')">
                                        <b-form-group label-cols="12" label="Status" label-size="sm">
                                            <treeselect placeholder="Select status..." v-model="status" :multiple="true"
                                                :clearable="false" :options="options_status" :show-count="true"
                                                :flatten-search-results="true" :disable-branch-nodes="true"
                                                :matchKeys="['id']" search-nested>
                                            </treeselect>
                                        </b-form-group>
                                    </b-col>
                                    <b-col>
                                        <b-form-group label-cols="12" label="Agent" label-size="sm">
                                            <b-input-group class="treeselect_all justify-content-end pr-2px">
                                                <span style="padding-top: 0.3em" class="text-primary"
                                                    id="agent-blocked">Blocked</span>
                                                <b-form-checkbox id="agent-blocked-check" v-model="isagentblocked"
                                                    class="z-0">
                                                </b-form-checkbox>
                                            </b-input-group>
                                            <b-input-group>
                                                <b-form-input v-model="agent" placeholder="Agent" trim></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary" :disabled="!agent"
                                                        @click="agent = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group> </b-form-group>
                                    </b-col>
                                </b-row>
                            </b-col>



                        </b-row>
                    </b-card-body>
                </b-card>

                <div class="px-3">
                    <!-- {{ inventorylines.offset }} {{ inventorylines.limit }} {{ inventorylines.page }} -->
                    <d-table classdivtable="availtable datatable credit-normal" refid="bookingforms"
                        :icon="inventorylines.icon" :toolbarlibrary="inventorylines.toolbarlibrary"
                        :tools="inventorylines.tools" :icons="inventorylines.icons" :badges="inventorylines.badges"
                        :fields="inventorylines.fields" :items="inventorylines.items"
                        :downloaded="inventorylines.downloaded" :busy="inventorylines.busy"
                        :offset="inventorylines.offset" :limit="inventorylines.limit" :page="inventorylines.page"
                        :showpages="true" @load="inventorylines_load" @click="inventorylines_click"
                        @select="inventorylines_select">
                    </d-table>

                </div>
            </div>

            <div v-show="component">
                <component :is="component" :selection="inventorylines.selected" :usesource="source" :config="cconfig"
                    @discard="inventorylines_click('discard')"></component>
            </div>

            <b-row class="px-3">
                <b-col>
                    <b-alert :show="message ? true : false" variant="success">
                        <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                                <i class="fa fa-exclamation-circle fa-2x"></i></b-col>
                            <b-col>
                                <span v-html="message"></span></b-col></b-row>
                    </b-alert></b-col>
            </b-row>

        </b-card>

    </div>
</template>

<script>
import { mapGetters } from "vuex";
import gql from "graphql-tag";

import InventoryLinesEdit from "./Components/InventoryLinesEdit";
import InventoryLinesInvoice from "./Components/InventoryLinesInvoice";
import InventoryLinesAmend from "./Components/InventoryLinesAmend";
import InventoryLinesPublish from "./Components/InventoryLinesPublish";
import AtolSale from "./Components/AtolSale";


export default {
    name: "InventoryLines",
    components: {
        InventoryLinesEdit,
        InventoryLinesInvoice,
        InventoryLinesAmend,
        InventoryLinesPublish,
        AtolSale

    },
    async mounted() {
        await this.accessdenied();
        try {
            const response = await this.$apollo.query({
                query: gql`
                        query suppliertypes {
                        suppliertypes {
                            id
                            label
                            faicon
                        }
                        }
                    `,
            });
            // this.options_suppliertype = response.data.suppliertypes;
            this.options_suppliertype = response.data.suppliertypes.filter(o => o.faicon != '');
        } catch (error) {
            console.log(error);
        }
        await this.inventorylines_load(0);
    },
    watch: {
        async issued_at() {
            await this.inventorylines_load(0);
        },
        async slaclike_visible() {
            await this.inventorylines_load(0);
        },
        async type() {
            await this.inventorylines_load(0);
        },
        async blac() {
            await this.inventorylines_load(0);
        },
        async slac() {
            await this.inventorylines_load(0);
        },
        async isslacblocked() {
            await this.inventorylines_load(0);
        },
        async slaclike() {
            await this.inventorylines_load(0);
        },
        async eventcode() {
            await this.inventorylines_load(0);
        },
        async iseventblocked() {
            await this.inventorylines_load(0);
        },
        async referenceno() {
            await this.inventorylines_load(0);
        },
        async agent() {
            await this.inventorylines_load(0);
        },
        async isagentblocked() {
            await this.inventorylines_load(0);
        },
        async travellers() {
            await this.inventorylines_load(0);
        },
        async token() {
            await this.inventorylines_load(0);
        },
        async description() {
            await this.inventorylines_load(0);
        },
        async locator() {
            if (this.locator.length > 0) {
                this.issued_at = { startDate: null, endDate: null }
                await this.inventorylines_load(0);
            } else {
                this.issued_at = { startDate: this.$moment().startOf("year").format("YYYY-MM-DD"), endDate: this.$moment().format("YYYY-MM-DD") }
            }
        },
        async status() {
            await this.inventorylines_load(0);
        },
        async source() {
            switch (this.source) {
                case "chold":
                    this.blac = ['BCARDCONF', 'SVPCONFU', 'SVPCONF']
                    break;
                case "xhold":
                    this.blac = ['WBAMEX']
                    break;
                default:
                    this.blac = []
            }
            if (this.inventorylines) {
                this.inventorylines.fields = this.inventorylines['fields_' + this.source]
            }
            await this.inventorylines_load(0);

        },
        async showdeployment() {
            this.referenceno = []
            this.token = []
        },
        async isinvoiced() {
            await this.inventorylines_load(0);
        },
        async invoiceno() {
            if (this.invoiceno.length > 0) {
                this.issued_at = { startDate: null, endDate: null }
                this.isinvoiced = ["1"]
                await this.inventorylines_load(0);
            } else {
                this.isinvoiced = ["0"]
                this.issued_at = { startDate: this.$moment().startOf("year").format("YYYY-MM-DD"), endDate: this.$moment().format("YYYY-MM-DD") }
            }
        },
        async hasnotes() {
            await this.inventorylines_load(0);
        },
        async notes() {
            if (this.notes.length > 0) {
                this.issued_at = { startDate: null, endDate: null }
                this.hasnotes = ["1"]

            } else {
                this.hasnotes = ["0"]
                this.issued_at = { startDate: this.$moment().startOf("year").format("YYYY-MM-DD"), endDate: this.$moment().format("YYYY-MM-DD") }
            }
            await this.inventorylines_load(0);
        },
        async travel_at() {
            await this.inventorylines_load(0);
        },
        async statement() {
            await this.inventorylines_load(0);
        },
        "window.width": {
            immediate: true,
            async handler(newVal, oldVal) {
                console.log('window.width', newVal)
                let state = this.inventorylines;
                if (newVal < 1550) {
                    // this.inventorylines.fields[6].class = "d-none"
                    if (state.fields[17]) {
                        state.fields[17].class = "d-none"
                    }
                    if (state.fields[18]) {
                        state.fields[18].class = "d-none"
                    }
                    if (state.fields[19]) {
                        state.fields[19].class = "d-none"
                    }
                } else {
                    // this.inventorylines.fields[6].class = "text-left"
                    if (state.fields[17]) {
                        state.fields[17].class = "text-center"
                    }
                    if (state.fields[18]) {
                        state.fields[18].class = "text-center"
                    }
                    if (state.fields[19]) {
                        state.fields[19].class = "text-center"
                    }
                }
            }
        },
        "cost.min": {
            immediate: true,
            async handler(newVal, oldVal) {
                if (!this.cost.max) { this.cost.max = this.cost.min }
                await this.inventorylines_load(0)
            }
        },
        "cost.max": {
            immediate: true,
            async handler(newVal, oldVal) {
                await this.inventorylines_load(0)
            }
        },

    },
    data() {
        return {
            busy: false,
            readonly: false,
            showfilter: false,
            message: null,
            issued_at: {
                startDate: null,
                endDate: null,
            },
            travel_at: {
                startDate: null,
                endDate: null,
            },
            confirmno: [],
            associatedno: [],
            invoiceno: [],
            statement: [],
            slac: [],
            slaclike: null,
            slaclike_visible: null,
            isslacblocked: false,
            blac: ['BCARDCONF', 'SVPCONFU', 'SVPCONF'],
            yourref: null,
            details: null,
            docno: [],
            passenger: null,
            locator: [],
            description: [],
            token: [],
            referenceno: [],
            showdeployment: null,
            eventcode: [],
            iseventblocked: false,
            isagentblocked: false,
            agent: null,
            cost: {
                min: null,
                max: null,
            },
            travellers: null,
            type: [],
            options_suppliertype: [],
            source: 'chold',
            options_source: [
                { id: "bhold", label: "Bhold" },
                { id: "chold", label: "Chold" },
                { id: "ghold", label: "Ghold" },
                { id: "xhold", label: "Xhold" },
                // { id: "zhold", label: "Zhold" },
            ],
            state: ["0"],
            options_state: [
                { id: "0", label: "Unsubmit" },
                { id: "1", label: "Submit" },
                // { id: "2", label: "Invoiced" },
            ],
            status: ["ready"],
            options_status: [
                { id: "ready", label: "Ready" },
                { id: "pending", label: "Pending" },
                { id: "cancelled", label: "Cancelled" },
                { id: "submitted", label: "Submitted" },
                { id: "unsubmitted", label: "Unsubmitted" },
            ],
            isinvoiced: ["0"],
            options_isinvoiced: [
                { id: '1', label: 'Yes' },
                { id: '0', label: 'No' },
            ],
            hasnotes: [],
            options_hasnotes: [
                { id: '1', label: 'Yes' },
                { id: '0', label: 'No' },
            ],
            notes: null,
            reason: null,
            reason_options: [],
            payby: [],
            payby_options: [],
            inventorylines: {
                title: "Charges ( Imported )",
                icon: "fa fa-puzzle-piece text-purple w-15px text-center",
                debounce: 1000,
                busy: false,
                page: 1,
                offset: 0,
                limit: 15,
                toolbarlibrary: [
                    {
                        type: "button",
                        size: "sm",
                        variant: "outline-white",
                        squared: "squared",
                        icon: "fa fa-retweet text-teal",
                        position: "toolbar",
                        action: "rebuild",
                        label: "Rebuild",
                        disabled: true,
                        component: {
                            name: "",
                        },
                    },
                    {
                        type: "button",
                        size: "sm",
                        variant: "outline-white",
                        squared: "squared",
                        icon: "fa fa-repeat text-primary",
                        position: "toolbar",
                        action: "amend",
                        label: "Amend",
                        component: {
                            name: "",
                        },
                    },
                    {
                        type: "button",
                        size: "sm",
                        variant: "outline-white",
                        squared: "squared",
                        icon: "fa fa-share text-purple",
                        position: "toolbar",
                        action: "publish",
                        label: "Publish",
                        component: {
                            name: "InventoryLinesPublish",
                        },
                    },
                    {
                        type: "button",
                        size: "sm",
                        variant: "outline-white",
                        squared: "squared",
                        icon: "fa fa-check-square-o text-purple",
                        position: "toolbar",
                        action: "atolsale",
                        label: "ATOLSALE",
                        component: {
                            name: "AtolSale",
                        },
                    },
                    {
                        type: "button",
                        size: "sm",
                        variant: "outline-white",
                        squared: "squared",
                        icon: "fa fa-ban text-danger",
                        position: "toolbar",
                        action: "nosale",
                        label: "NOSALE",
                        component: {
                            name: "",
                        },
                    },
                    {
                        type: "button",
                        size: "sm",
                        variant: "outline-white",
                        squared: "squared",
                        icon: "fa fa-commenting-o",
                        position: "toolbar",
                        action: "notes",
                        label: "Notes",
                        component: {
                            name: "",
                        },
                    },
                    {
                        type: "button",
                        size: "sm",
                        variant: "outline-white",
                        squared: "squared",
                        icon: "fa fa-envelope text-warning",
                        position: "toolbar",
                        action: "email",
                        label: "Email",
                        component: {
                            name: "",
                        },
                    },
                    {
                        type: "button",
                        size: "sm",
                        variant: "outline-white",
                        squared: "squared",
                        icon: "fa fa-envelope text-danger",
                        position: "toolbar",
                        action: "noagent",
                        label: "Blocked Agents",
                        component: {
                            name: "",
                        },
                    },

                ],
                // tools:
                // "go,filter,export,clipboard,add,amend,edit,fix,nosale,publish,atolsale,deleteconfirm,invoice,email",
                tools:
                    "go,filter,download,clipboard,fix,amend,edit,publish,deleteconfirm,atolsale,nosale,invoice,email,noagent",
                fields: [],
                fields_bhold: [
                    {
                        key: "selected",
                        label: "...",
                        class: "text-center w-25px",
                    },
                    {
                        key: "icon",
                        label: "",
                        class: "text-right w-50px",
                    },
                    {
                        key: "issued_at",
                        label: "Issued",
                        sortable: true,
                        class: "text-center nowrap",
                        formatter: (value, key, item) => {
                            let result = "";
                            if (value) {
                                result = this.$moment
                                    .unix(value / 1000)
                                    .utc(false)
                                    .format("DD/MM/YYYY");
                            }
                            return result;
                        },
                    },
                    {
                        key: "referenceno",
                        label: "TransactionId",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "traveller",
                        label: "Traveller",
                        sortable: true,
                        class: "text-left",
                        formatter: (value, key, item) => {
                            let result = value;
                            if (result) {
                                if (result.length > 30) {
                                    result = result.slice(0, 29) + "...";
                                }
                            }
                            return result;
                        },
                    },
                    {
                        key: "start_at",
                        label: "Date Travel",
                        sortable: true,
                        class: "text-center nowrap",
                        formatter: (value, key, item) => {
                            let result = "";
                            if (value) {
                                result = this.$moment
                                    .unix(value / 1000)
                                    .utc(false)
                                    .format("DD/MM/YYYY");
                            }
                            return result;
                        },
                    },
                    {
                        key: "slac",
                        label: "SL A/C",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "eventcode",
                        label: "Event",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "blac",
                        label: "BL A/C",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "cost",
                        label: "Cost",
                        sortable: true,
                        class: "text-right",
                        totalled: true,
                        total: 0,
                    },
                    {
                        key: "markup",
                        label: "Markup",
                        sortable: true,
                        class: "text-right",
                        totalled: true,
                        total: 0,
                    },
                    {
                        key: "sale",
                        label: "Sale",
                        sortable: true,
                        class: "text-right",
                        totalled: true,
                        total: 0,
                    },
                    {
                        key: "agent",
                        label: "Agent",
                        sortable: true,
                    },
                    {
                        key: "status",
                        label: "Status",
                        sortable: true,
                    },
                    {
                        key: "invoiceno",
                        label: "InvoiceNo",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "statement",
                        label: "Statement",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "updated_by",
                        label: "Updated By",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                    },
                    {
                        key: "updated_at",
                        label: "Updated At",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                    },
                    {
                        key: "actions",
                        label: "Actions",
                        class: "actions w-110px",
                    },
                ],
                fields_chold: [
                    {
                        key: "selected",
                        label: "...",
                        class: "text-center w-25px",
                    },
                    {
                        key: "icon",
                        label: "",
                        class: "text-right w-50px",
                    },
                    {
                        key: "issued_at",
                        label: "Issued",
                        sortable: true,
                        class: "text-center nowrap",
                        formatter: (value, key, item) => {
                            let result = "";
                            if (value) {
                                result = this.$moment
                                    .unix(value / 1000)
                                    .utc(false)
                                    .format("DD/MM/YYYY");
                            }
                            return result;
                        },
                    },
                    {
                        key: "last4",
                        label: "Last4",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "referenceno",
                        label: "TransactionId",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "token",
                        label: "DeploymentId",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "description",
                        label: "Payee",
                        sortable: true,
                        class: "text-left",
                        formatter: (value, key, item) => {
                            let result = value;
                            if (result) {
                                if (result.length > 10) {
                                    result = result.slice(0, 10) + "...";
                                }
                            }
                            return result;
                        },
                    },
                    {
                        key: "start_at",
                        label: "Date Travel",
                        sortable: true,
                        class: "text-center nowrap",
                        formatter: (value, key, item) => {
                            let result = "";
                            if (value) {
                                result = this.$moment
                                    .unix(value / 1000)
                                    .utc(false)
                                    .format("DD/MM/YYYY HH:mm");
                            }
                            return result;
                        },
                    },
                    {
                        key: "slac",
                        label: "SL A/C",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "eventcode",
                        label: "Event",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "blac",
                        label: "BL A/C",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "cost",
                        label: "Cost",
                        sortable: true,
                        class: "text-right",
                        totalled: true,
                        total: 0,
                    },
                    {
                        key: "markup",
                        label: "Markup",
                        sortable: true,
                        class: "text-right",
                        totalled: true,
                        total: 0,
                    },
                    {
                        key: "sale",
                        label: "Sale",
                        sortable: true,
                        class: "text-right",
                        totalled: true,
                        total: 0,
                    },
                    {
                        key: "agent",
                        label: "Agent",
                        sortable: true,
                    },
                    {
                        key: "status",
                        label: "Status",
                        sortable: true,
                    },
                    {
                        key: "invoiceno",
                        label: "InvoiceNo",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "statement",
                        label: "Statement",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "updated_by",
                        label: "Updated By",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                    },
                    {
                        key: "updated_at",
                        label: "Updated At",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                    },
                    {
                        key: "actions",
                        label: "Actions",
                        class: "actions w-110px",
                    },
                ],
                fields_ghold: [
                    {
                        key: "selected",
                        label: "...",
                        class: "text-center w-25px",
                    },
                    {
                        key: "icon",
                        label: "",
                        class: "text-right w-50px",
                    },
                    {
                        key: "issued_at",
                        label: "Issued",
                        sortable: true,
                        class: "text-center nowrap",
                        formatter: (value, key, item) => {
                            let result = "";
                            if (value) {
                                result = this.$moment
                                    .unix(value / 1000)
                                    .utc(false)
                                    .format("DD/MM/YYYY");
                            }
                            return result;
                        },
                    },
                    {
                        key: "referenceno",
                        label: "TransactionId",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "traveller",
                        label: "Traveller",
                        sortable: true,
                        class: "text-left",
                        formatter: (value, key, item) => {
                            let result = value;
                            if (result) {
                                if (result.length > 30) {
                                    result = result.slice(0, 29) + "...";
                                }
                            }
                            return result;
                        },
                    },
                    {
                        key: "start_at",
                        label: "Date Travel",
                        sortable: true,
                        class: "text-center nowrap",
                        formatter: (value, key, item) => {
                            let result = "";
                            if (value) {
                                result = this.$moment
                                    .unix(value / 1000)
                                    .utc(false)
                                    .format("DD/MM/YYYY");
                            }
                            return result;
                        },
                    },
                    {
                        key: "slac",
                        label: "SL A/C",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "eventcode",
                        label: "Event",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "blac",
                        label: "BL A/C",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "cost",
                        label: "Cost",
                        sortable: true,
                        class: "text-right",
                        totalled: true,
                        total: 0,
                    },
                    {
                        key: "markup",
                        label: "Markup",
                        sortable: true,
                        class: "text-right",
                        totalled: true,
                        total: 0,
                    },
                    {
                        key: "sale",
                        label: "Sale",
                        sortable: true,
                        class: "text-right",
                        totalled: true,
                        total: 0,
                    },
                    {
                        key: "agent",
                        label: "Agent",
                        sortable: true,
                    },
                    {
                        key: "status",
                        label: "Status",
                        sortable: true,
                    },
                    {
                        key: "invoiceno",
                        label: "InvoiceNo",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "statement",
                        label: "Statement",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "updated_by",
                        label: "Updated By",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                    },
                    {
                        key: "updated_at",
                        label: "Updated At",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                    },
                    {
                        key: "actions",
                        label: "Actions",
                        class: "actions w-110px",
                    },
                ],
                fields_xhold: [
                    {
                        key: "selected",
                        label: "...",
                        class: "text-center w-25px",
                    },
                    {
                        key: "icon",
                        label: "",
                        class: "text-right w-50px",
                    },
                    {
                        key: "issued_at",
                        label: "Issued",
                        sortable: true,
                        class: "text-center nowrap",
                        formatter: (value, key, item) => {
                            let result = "";
                            if (value) {
                                result = this.$moment
                                    .unix(value / 1000)
                                    .utc(false)
                                    .format("DD/MM/YYYY");
                            }
                            return result;
                        },
                    },
                    {
                        key: "referenceno",
                        label: "TransactionId",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "description",
                        label: "Payee",
                        sortable: true,
                        class: "text-left",
                        formatter: (value, key, item) => {
                            let result = value;
                            if (result) {
                                if (result.length > 10) {
                                    result = result.slice(0, 10) + "...";
                                }
                            }
                            return result;
                        },
                    },
                    {
                        key: "start_at",
                        label: "Date Travel",
                        sortable: true,
                        class: "text-center nowrap",
                        formatter: (value, key, item) => {
                            let result = "";
                            if (value) {
                                result = this.$moment
                                    .unix(value / 1000)
                                    .utc(false)
                                    .format("DD/MM/YYYY");
                            }
                            return result;
                        },
                    },
                    {
                        key: "slac",
                        label: "SL A/C",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "eventcode",
                        label: "Event",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "blac",
                        label: "BL A/C",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "cost",
                        label: "Cost",
                        sortable: true,
                        class: "text-right",
                        totalled: true,
                        total: 0,
                    },
                    {
                        key: "markup",
                        label: "Markup",
                        sortable: true,
                        class: "text-right",
                        totalled: true,
                        total: 0,
                    },
                    {
                        key: "sale",
                        label: "Sale",
                        sortable: true,
                        class: "text-right",
                        totalled: true,
                        total: 0,
                    },
                    {
                        key: "agent",
                        label: "Agent",
                        sortable: true,
                    },
                    {
                        key: "status",
                        label: "Status",
                        sortable: true,
                    },
                    {
                        key: "invoiceno",
                        label: "InvoiceNo",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "statement",
                        label: "Statement",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "updated_by",
                        label: "Updated By",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                    },
                    {
                        key: "updated_at",
                        label: "Updated At",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                    },
                    {
                        key: "actions",
                        label: "Actions",
                        class: "actions w-110px",
                    },
                ],
                icons: [
                    {
                        key: "type",
                        A: "fa fa-plane text-primary w-15px text-center",
                        C: "fa fa-car text-info w-15px text-center",
                        H: "fa fa-bed text-orange w-15px text-center",
                        B: "fa fa-suitcase text-purple w-15px text-center",
                        R: "fa fa-train text-danger w-15px text-center",
                        G: "fa fa-bus text-dark w-15px text-center",
                        F: "fa fa-ship text-danger w-15px text-center",
                    }
                ],
                badges: [
                    {
                        key: "confirmno",
                        type: "pill",
                        class: "orange",
                    },

                    {
                        key: "locator",
                        type: "pill",
                        class: "secondary",
                    },

                    {
                        key: "qty",
                        type: "pill",
                        class: "white",
                    },
                    {
                        key: "pax",
                        type: "pill",
                        class: "white",
                    },
                    {
                        key: "equipment",
                        type: "pill",
                        class: "purple",
                    },
                    {
                        key: "payby",
                        type: "pill",
                        class: "secondary",
                    },
                    {
                        key: "blac",
                        type: "pill",
                        class: "white",
                    },
                    {
                        key: "statement",
                        type: "pill",
                        class: "secondary",
                    },
                    {
                        key: "status",
                        type: "badge",
                        pending: "warning",
                        ready: "purple",
                        cancelled: "danger",
                        submitted: "danger",
                        unsubmitted: "info"
                    },
                ],
                items: [],
                selected: [],
                downloaded: [],
                denied: [],
            }
        };
    },
    computed: {
        ...mapGetters(["window"]),
    },
    methods: {
        accessdenied() {
            this.inventorylines.denied = [];
            if (!this.user.permissions.includes("systems.development")) {
                this.inventorylines.denied.push("wizard");
            }

            if (!this.user.permissions.includes("conferma.admin")) {
                this.inventorylines.denied.push("save");
                this.inventorylines.denied.push("deleteconfirm");
                this.inventorylines.denied.push("add");
                this.inventorylines.denied.push("amend");
                this.inventorylines.denied.push("fix");
                this.inventorylines.denied.push("nosale");
                this.inventorylines.denied.push("publish");
                this.inventorylines.denied.push("atolsale");
                this.inventorylines.denied.push("email");
                this.inventorylines.denied.push("noagent");
            }

        },

        async inventorylines_load(offset, limit, page) {

            console.log('inventorylines_load', offset, limit, page)
            this.message = null
            this.inventorylines.fields = this.inventorylines['fields_' + this.source]

            let state = this.inventorylines

            if (offset || offset == 0) {
                state.offset = offset
            }
            if (limit || limit == 0) {
                state.limit = limit
            }
            if (page) {
                state.page = page
            }

            if (limit != 0) { state.busy = true }

            let variables = {
                offset: state.offset,
                limit: state.limit,
                blac: this.blac.length > 0 ? this.blac.join(",") : null,
                slac: this.slac.length > 0 ? this.slac.join(",") : null,
                slaclike: this.slaclike,
                isslacblocked: this.isslacblocked,
                type: this.type.length > 0 ? this.type.join(",") : null,
                eventcode: this.eventcode.length > 0 ? this.eventcode.join(",") : null,
                iseventblocked: this.iseventblocked,
                isagentblocked: this.isagentblocked,
                issued_at: [
                    this.issued_at.startDate
                        ? this.$moment(this.issued_at.startDate).format("YYYY-MM-DD")
                        : null,
                    this.issued_at.endDate
                        ? this.$moment(this.issued_at.endDate).format("YYYY-MM-DD")
                        : null,
                ],
                yourref: this.yourref,
                locator: this.locator.length > 0 ? this.locator.join(",") : null,
                description: this.description.length > 0 ? this.description.join(",") : null,
                referenceno: this.referenceno.length > 0 ? this.referenceno.join(",") : null,
                token: this.token.length > 0 ? this.token.join(",") : null,
                status: this.status.length > 0 ? this.status.join(",") : null,
                source: this.source,
                isinvoiced: this.isinvoiced.length == 0 ? null : this.isinvoiced.includes('1') ? true : false,
                hasnotes: this.hasnotes.length == 0 ? null : this.hasnotes.includes('1') ? true : false,
                notes: this.notes,
                cost: this.cost.min ? [this.cost.min, this.cost.max] : null,
                // source: this.source.length > 0 ? this.source.join(",") : null,
                // type: this.type.length > 0 ? this.type.join(",") : null,
                // state: this.state.length > 0 ? this.state.join(",") : null,              
                travel_at: [
                    this.travel_at.startDate
                        ? this.$moment(this.travel_at.startDate).format("YYYY-MM-DD")
                        : null,
                    this.travel_at.endDate
                        ? this.$moment(this.travel_at.endDate).format("YYYY-MM-DD")
                        : null,
                ],
                // confirmno: this.confirmno.length > 0 ? this.confirmno.join(",") : null,
                // associatedno: this.associatedno.length > 0 ? this.associatedno.join(",") : null,               
                // passenger: this.passenger,
                invoiceno: this.invoiceno.length > 0 ? this.invoiceno.join(",") : null,
                statement: this.statement.length > 0 ? this.statement.join(",") : null,
                agent: this.agent,
                travellers: this.travellers,
                // blac: this.blac,
                // // reason: this.reason.length > 0 ? this.reason.join(",") : null,
                // payby: this.payby.length > 0 ? this.payby.join(",") : null,             
                // docno: this.docno.length > 0 ? this.docno.join(",") : null,
                // details: this.details,
                dateformat: "DD/MM/YYYY HH:MM:SS",
            };

            console.log("variables", variables);
            try {
                const response = await this.$apollo.query({
                    query: gql`
              query inventorylines(             
                $offset: Int
                $limit: Int
                $issued_at: [String]
                $slac: String
                $slaclike: String
                $isslacblocked: Boolean
                $eventcode: String
                $iseventblocked: Boolean
                $isagentblocked: Boolean
                $yourref: String
                $locator: String    
                $description: String  
                $referenceno: String    
                $token: String    
                $status: String           
                $source: String  
                $isinvoiced: Boolean  
                $hasnotes: Boolean  
                $type: String   
                $notes: String  
                 $travel_at: [String]             
                $blac: String
                $invoiceno: String  
                $statement: String  
                $agent: String 
                $cost: [String]
                $travellers: String     
                $dateformat: String
              ) {
                    inventorylines(                 
                    offset: $offset
                    limit: $limit
                    issued_at: $issued_at
                    slac: $slac
                    slaclike: $slaclike
                    isslacblocked: $isslacblocked
                    iseventblocked: $iseventblocked
                    isagentblocked: $isagentblocked
                    eventcode: $eventcode
                    yourref: $yourref
                    locator: $locator
                    description: $description
                    referenceno: $referenceno
                    token: $token
                    status: $status
                    source: $source 
                    isinvoiced: $isinvoiced     
                    hasnotes: $hasnotes   
                    notes: $notes               
                    dateformat: $dateformat
                    type: $type
                    travel_at: $travel_at              
                    invoiceno: $invoiceno  
                    statement: $statement  
                    blac: $blac                   
                    agent: $agent  
                    cost: $cost
                    travellers: $travellers                
                    ) {
                    id
                    type
                    issued_at
                    source
                    invoicetype
                    description                   
                    last4
                    token
                    referenceno
                    reference
                    yourref
                    qty
                    traveller
                    start_at
                    blac  
                    cost                    
                    markup
                    sale                                       
                    slac
                    eventcode             
                    agent
                    status
                    invoiceno
                    statement
                    updated_at
                    updated_by
                    rows
                    }
                }
                `,
                    variables,
                });

                // USE LOCAL VARIABLE
                state.downloaded = []
                if (limit == 0) {
                    state.downloaded = response.data.inventorylines
                } else {
                    state.items = response.data.inventorylines;
                }

            } catch (error) {
                console.log(error);
            }


            //     try {
            //         const response = await this.$apollo.query({
            //             query: gql`
            //                 query bookingformspaytypes {
            //                     bookingformspaytypes {
            //                         id
            //                         label
            //                     }
            //                 }
            //             `,
            //         });
            //         this.payby_options = response.data.bookingformspaytypes;
            //     } catch (error) {
            //     }

            //     try {
            //         const response = await this.$apollo.query({
            //             query: gql`
            //     query bookingformsreasontypes {
            //       bookingformsreasontypes {
            //         id
            //         label: name
            //       }
            //     }
            //   `,
            //         });
            //         this.reason_options = response.data.bookingformsreasontypes;
            //     } catch (error) {
            //     }


            state.busy = false;

            this.$store.dispatch("chold");

        },

        async inventorylines_click(a, ss) {

            let state = this.inventorylines

            switch (a) {
                case "filter":
                    this.showfilter = !this.showfilter;
                    break;

                case "download_view":
                    state.downloaded = []
                    state.downloaded = state.items
                    break;

                case "download_all":
                    state.downloaded = []
                    await this.inventorylines_load(0, 0);
                    break;

                case "discard":
                    this.component = null;
                    break;

                case "go":
                    this.component = null;
                    //   this.dateSelector();
                    await this.inventorylines_load(0);
                    break;

                case "add":
                case "edit":
                    this.component = "InventoryLinesEdit";
                    break;

                case "publish":
                    this.component = "InventoryLinesPublish";
                    break;

                case "nosale":
                    await this.inventorylines_nosale(ss);
                    break;

                case "fix":
                    await this.inventorylines_fix()
                    break;

                case "atolsale":
                    // state.limit=5000
                    // state.offset=0

                    // SET
                    this.slaclike_visible = true
                    this.slaclike = 'ATOLSALE'
                    this.blac = ['BCARDCONF']
                    this.status = ['ready']


                    // CLEAR
                    this.issued_at = { startDate: null, endDate: null }
                    this.travel_at = { startDate: null, endDate: null }
                    this.type = []
                    this.slac = []
                    this.eventcode = []
                    this.referenceno = []
                    this.agent = null
                    this.travellers = null
                    this.token = []
                    this.locator = []
                    this.yourref = null
                    this.isinvoiced = ["0"]
                    this.invoiceno = []
                    this.statement = []
                    this.hasnotes = ["0"]
                    this.notes = null

                    break;

                case "email":
                    await this.inventorylines_email(ss)
                    break;

                case "noagent":
                    await this.inventorylines_email_blockedagents(ss)
                    break;

                case "delete":
                    await this.inventorylines_delete(ss);
                    break;

                case "amend":
                    this.component = "InventoryLinesAmend";
                    break;

                case "invoice":
                    if (ss.length > 0) {
                        if (ss[0].invoiceno) {
                            this.message = null
                            this.component = "InventoryLinesInvoice";
                        } else {
                            // this.message = "Invoice has not been posted yet! use <i class='fa fa-share text-info'></i> Assign to draft an invoice."
                            this.message = "Invoice has not been posted yet! Charge is awaiting an invoicing action."
                            this.component = null;
                        }
                    }
                    break;


            }
        },
        async inventorylines_select(ss, tools) {
            this.message = null
            let state = this.inventorylines

            state.selected = ss;
            let tool = null;

            if (tools) {
                let enabled = [
                    "back",
                    "save",
                    "go",
                    "filter",
                    "download",
                    "clipboard",
                    "add",
                    "fix",
                    "assign",
                    "atolsale",
                    "publish",
                    "email",
                    "noagent"
                ];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = false;
                    }
                });
                // == 1            
                //   , "receiptview"
                enabled = ["edit", "clone", "notes", "invoice", "wizard", "rebuild"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length == 1 ? false : true;
                    }
                });
                // > 1
                //, "submit", "receiptemail"
                enabled = ["deleteconfirm", "amend", "nosale"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length > 0 ? false : true;
                    }
                });

                if (!state.denied) {
                    state.denied = [];
                }
                state.denied.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.visible = false;
                    }
                });
            }
        },

        async inventorylines_delete(ss) {
            console.log("inventorylines_delete", ss);

            let state = this.inventorylines;

            state.busy = true

            let rows = [];
            ss.forEach(function (v) {
                rows.push({ id: v.id });
            });

            let variables = {
                rows,
            };

            console.log(variables);
            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
              mutation inventorylines_delete($rows: [InventoryLine_input]) {
                inventorylines_delete(rows: $rows) {
                  id
                }
              }
            `,
                    variables,
                });
            } catch (error) {
                console.log(error);
            }

            state.busy = false

            await this.inventorylines_load(0);
        },

        async inventorylines_email(ss, tools) {

            let state = this.inventorylines;

            if (await this.$bvModal.msgBoxConfirm('Email the agents?', {
                title: 'Please confirm you want to email the agents with outstanding \"' + this.source + '\" charges?',
                size: 'lg',
                buttonSize: 'sm',
                okVariant: 'success',
                okTitle: 'Yes',
                cancelTitle: 'No',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })) {

                state.busy = true
                let variables = {
                    source: this.source,
                };

                try {
                    const response = await this.$apollo.query({
                        query: gql`
                            query inventorylines_email($source: String) {
                                inventorylines_email (source: $source) 
                                }
                                `,
                        variables,
                    });
                } catch (error) {
                    console.log(error);
                }

                state.busy = false
            } else {
                state.busy = false
            }
            await this.inventorylines_load(0);

        },

        async inventorylines_email_blockedagents(ss, tools) {

            console.log("inventorylines_email_blockedagents", ss);

            let state = this.inventorylines;

            if (await this.$bvModal.msgBoxConfirm('Email the agents?', {
                title: 'Please confirm you want to send the email to show all blocked \"' + this.source + '\" agents?',
                size: 'lg',
                buttonSize: 'sm',
                okVariant: 'success',
                okTitle: 'Yes',
                cancelTitle: 'No',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })) {

                state.busy = true
                let variables = {
                    source: this.source,
                    type: "blockedagents"
                };
                console.log(variables);

                try {
                    const response = await this.$apollo.query({
                        query: gql`
                            query inventorylines_email($type: String,  $source: String) {
                                inventorylines_email (type: $type, source: $source) 
                                }
                        `,
                        variables,
                    });
                } catch (error) {
                    console.log(error);
                }

                state.busy = false
            } else {
                state.busy = false
            }
            await this.inventorylines_load(0);

        },

        async inventorylines_nosale(ss, tools) {

            console.log("inventorylines_nosale", ss);

            let state = this.inventorylines;

            if (await this.$bvModal.msgBoxConfirm('Update the selected rows to no sale ( markup = -cost, sale = 0 )', {
                title: 'Are you sure you want to update to no sale ?',
                size: 'lg',
                buttonSize: 'sm',
                okVariant: 'success',
                okTitle: 'Yes',
                cancelTitle: 'No',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })) {

                state.busy = true

                let rows = ss.map(o => ({ id: o.id }));

                let variables = {
                    rows,
                };

                try {
                    const response = await this.$apollo.mutate({
                        mutation: gql`
                            mutation inventorylines_nosale($rows: [InventoryLine_input]) {
                                inventorylines_nosale(rows: $rows) {
                                id
                                }
                            }
                         `,
                        variables,
                    });
                } catch (error) {
                    console.log(error);
                }

                state.busy = false
            } else {
                state.busy = false
            }
            await this.inventorylines_load(0);
        },

        async inventorylines_fix(ss, tools) {

            let state = this.inventorylines;

            if (await this.$bvModal.msgBoxConfirm('Update the uninvoiced rows to the latest parsing logic?', {
                title: 'Are you sure you want to update all rows with latest logic ?',
                size: 'lg',
                buttonSize: 'sm',
                okVariant: 'success',
                okTitle: 'Yes',
                cancelTitle: 'No',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })) {

                state.busy = true
                
                let variables = {
                    source: this.source,
                };

                try {
                    const response = await this.$apollo.mutate({
                        mutation: gql`
                            mutation inventorylines_fix($source: String) {
                                inventorylines_fix(source: $source) 
                            }
                         `,
                        variables,
                    });
                } catch (error) {
                    console.log(error);
                }


            } else {
                state.busy = false
            }
            await this.inventorylines_load(0);

        }
    },
};
</script>